import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full md:p-6 p-4 mx-auto my-6 border border-gray-200 rounded"
}
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "grid grid-cols-6 gap-6 mt-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 border-t border-gray-200" }, null, -1)
const _hoisted_5 = { class: "col-span-6" }
const _hoisted_6 = { class: "flex flex-1 md:space-x-6 md:space-y-0 space-y-3 md:flex-row flex-col" }
const _hoisted_7 = { class: "md:w-1/3 w-full" }
const _hoisted_8 = { class: "md:w-1/3 w-full" }
const _hoisted_9 = { class: "md:w-1/3 w-full" }
const _hoisted_10 = { class: "shrink-0 md:pt-[26px] pt-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Search", -1)
const _hoisted_12 = {
  key: 1,
  class: "w-full md:p-6 p-4 mx-auto my-6 border border-gray-200 rounded"
}
const _hoisted_13 = { class: "flex items-center justify-between mb-6 md:flex-row flex-col md:space-y-0 space-y-6" }
const _hoisted_14 = { class: "flex items-center space-x-3 md:w-auto w-full" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Search", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium text-neutral-600" }, "Showing:", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-semibold" }, "All Records", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "space-y-5" }
const _hoisted_20 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_21 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_22 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_23 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_24 = { class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap" }
const _hoisted_25 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_26 = { class: "flex items-center justify-center mx-auto" }
const _hoisted_27 = { class: "w-full px-6 border-t py-7" }

import { ref, watch, computed } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import ViewButton from "@/components/buttons/ViewButton.vue";
import DataTable from "@/components/partials/DataTable.vue";
import FilterPanel from "@/components/partials/FilterPanel.vue";
import MinifyPagination from "@/components/partials/MinifyPagination.vue";
import SelectOptions from "@/components/inputs/SelectOptions.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import { useRouter, useRoute } from "vue-router";
import PerpetratorService from "@/classes/Perpetrators/PerpetratorService";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import PageLoader from "@/components/loaders/PageLoader.vue"
import { hasPermission } from "@/classes/AuthService";
import { useNetworkStore } from "@/store/network"; 
import { PerpetratorSearch } from "@/interfaces/Cases/Perpetrator";
import TextInput from "@/components/inputs/TextInput.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import { errorResponse } from "@/helpers/errorMessage";
import { onIonViewWillEnter } from "@ionic/vue";
import SearchTwoIcon from "@/components/icons/searchTwoIcon.vue";
import Rules from "@/classes/Patients/Offline/Validation/Rules";
import useVuelidate from "@vuelidate/core";
import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";
 

export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const loading = ref<boolean>(false);
const showFilter = ref<boolean>(false);
const router = useRouter();
const route = useRoute();

/**
 * VARIABLES
 */
const items = ref<any>(null);
const filterSearch = ref<any>(route.query.query);
const filterDate = ref<any>(route.query.date);
const filterGender = ref<any>(route.query.gender);
const page = ref<any>(route.query.page);
const lastPage = ref<any>(null);
const rows = ref<any>(route.query.rows);
const numRows = computed(() => (rows.value ? rows.value + " Rows" : "All"));
const genderOptions = ref([]);
const offlineParams = ref<string>(route.query.offline);
const errors = ref<any>({});
const viewSearch = ref<boolean>(true);
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const { searchRules } = Rules;

const headers: { text: string; haveSort?: boolean }[] = [
	{ text: "Perpetrator Name", haveSort: true },
	{ text: "Birthday", haveSort: true },
	{ text: "Gender", haveSort: true },
	{ text: "Type", haveSort: true },
	{ text: "Date Created", haveSort: true },
];

const form = ref<PerpetratorSearch>({
	last_name: null,
	first_name: null,
	birthdate: null,
});

/**
 * METHODS
 */
const getData = async (search: any = null): Promise<any> => {
	loading.value = true

    const response = await PerpetratorService.search(
		pickBy({
			...{
				...form.value,
				query: search ?? filterSearch.value,
				date: filterDate.value,
				gender: filterGender.value?.toString(),
				page: page.value,
				rows: rows.value,
			},
		}),
        isNetworkAvailable.value 
	);

    if (response?.status === 200 || response?.data != undefined) {
 
		items.value = response.data.items.data;
		genderOptions.value = response.data.genders;
		page.value = response.data.items.current_page;
		lastPage.value = response.data.items.last_page;
        
        loading.value = false;
        viewSearch.value = false;
    } else {
        const error = response;
        loading.value = false;
        errors.value = errorResponse(error.response?.data?.errors)
    }
};

const reloadPage = async () => {
	return await router.push({
		path: "/perpetrator/index",
		query: pickBy({
			query: filterSearch.value,
			date: filterDate.value,
			gender: filterGender.value?.toString(),
			page: page.value,
			rows: rows.value,
		}),
	});
};

const applyFilters = () => {
	reloadPage().then(() => {
		showFilter.value = false;
		getData();
	});
};

const applyReset = () => {
	filterDate.value = "";
	filterGender.value = "";
	reloadPage().then(() => {
		getData();
		showFilter.value = false;
	});
};

const paginate = (data: number): void => {
	page.value = data;
	applyFilters();
};

const changeRows = (row: any): void => {
	rows.value = row;
	applyFilters();
};

/**
 * Validate the form using Vuelidator
 */
 const validateForm = async () =>{
	const vuelidate = useVuelidate(searchRules({...form.value}), form.value)
	const result = await vuelidate.value.$validate();

    if (result) {
        return null;
    } else {
        errors.value = ErrorValidation.getErrors(vuelidate.value);
        errorResponse(errors.value);
        return errors.value;
    }
}

const search = async (): Promise<any> => {
    // Set validation rule for Online and Offline
    const validate = await validateForm();
    if (validate) {
        return;
    }

	await getData();
}

const resetForm = () => {
    form.value.last_name = null;
    form.value.first_name = null;
    form.value.birthdate = null;
}

/**
 * WATCHERS
 */
watch(
	filterSearch,
	throttle((val: string) => {
		reloadPage().then(() => {
            page.value = 1;
			getData(val);
		});
	}, 1500)
);
 
onIonViewWillEnter(() => {
    resetForm();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      (viewSearch.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(SectionTitle, { title: "Search Perpetrator" })
            ]),
            _createElementVNode("form", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(TextInput, {
                      type: "text",
                      label: "First Name",
                      placeholder: "First name",
                      name: "first_name",
                      id: "first_name",
                      modelValue: form.value.first_name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.first_name) = $event)),
                      error: errors.value?.first_name
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(TextInput, {
                      type: "text",
                      label: "Last Name",
                      placeholder: "Last name",
                      name: "last_name",
                      id: "last_name",
                      modelValue: form.value.last_name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.last_name) = $event)),
                      error: errors.value?.last_name
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(DatePicker, {
                      id: "birthdate",
                      name: "birthdate",
                      label: "Birthdate",
                      modelValue: form.value.birthdate,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.birthdate) = $event)),
                      error: errors.value?.birthdate
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(ButtonComponent, {
                      customClass: "quaternary md:w-auto w-full",
                      size: "large",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (search()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SearchTwoIcon, { class: "object-contain w-5 h-5 mr-1 icon" }),
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(SectionTitle, {
                title: "Search Perpetrator",
                description: "View the data analytics in the system.",
                class: "md:w-auto w-full"
              }),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(ButtonComponent, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (viewSearch.value = true)),
                  customClass: "quaternary md:w-auto w-full",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createVNode(SearchTwoIcon, { class: "object-contain w-5 h-5 mr-1 icon" }),
                    _hoisted_15
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(DataTable, {
                headers: headers,
                "no-action": false,
                count: items.value?.length,
                hasSearch: false,
                search: filterSearch.value,
                "onUpdate:searchText": _cache[13] || (_cache[13] = (value) => (filterSearch.value = value)),
                searchPlaceholder: "Search perpetrator name",
                tableClass: "header-frm-table five"
              }, {
                topContent: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "flex items-center px-3 py-2 space-x-1 transition border border-solid rounded border-neutral-100 hover:bg-primary-100 w-max",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showFilter.value = true))
                    }, _hoisted_18),
                    _createVNode(FilterPanel, {
                      show: showFilter.value,
                      onClose: _cache[8] || (_cache[8] = ($event: any) => (showFilter.value = false)),
                      "onApply:reset": _cache[9] || (_cache[9] = ($event: any) => (applyReset())),
                      "onApply:filters": _cache[10] || (_cache[10] = ($event: any) => (applyFilters()))
                    }, {
                      fields: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(DatePicker, {
                            id: "date_created",
                            name: "date_created",
                            label: "Date Created",
                            range: true,
                            modelValue: filterDate.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filterDate).value = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(SelectOptions, {
                            options: genderOptions.value,
                            label: "Gender",
                            id: "gender",
                            name: "gender",
                            placeholder: "Select..",
                            modelValue: filterGender.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = (newValue) => (filterGender.value = newValue))
                          }, null, 8, ["options", "modelValue"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["show"])
                  ])
                ]),
                body: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", { key: item }, [
                      _createElementVNode("td", _hoisted_20, _toDisplayString(item.name), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(item.birthdate_formatted || item.birthdate || item.computed_age), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(item.gender_meta?.description), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(item.identity_meta?.description), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(item.created_at_formatted), 1),
                      _createElementVNode("td", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          (_unref(hasPermission)('can-view-perpetrator'))
                            ? (_openBlock(), _createBlock(ViewButton, {
                                key: 0,
                                onClick: ($event: any) => (
												_unref(router).replace(
													`/perpetrator/${item.id}/view`
												)
											)
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                tfoot: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(MinifyPagination, {
                      numRows: numRows.value,
                      "onUpdate:rows": _cache[11] || (_cache[11] = (value) => changeRows(value)),
                      "onUpdate:page": _cache[12] || (_cache[12] = (value) => paginate(value)),
                      "current-page": page.value,
                      "last-page": lastPage.value
                    }, null, 8, ["numRows", "current-page", "last-page"])
                  ])
                ]),
                _: 1
              }, 8, ["count", "search"])
            ])
          ])),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})